export default "__VITE_ASSET__9776972c__"